import {
    Card,
    CardBody,
    Button,
    CardHeader,
    Divider,
    CardFooter,
} from "@heroui/react";
import { useNavigate } from "react-router-dom";
import { formatDate } from "@/utils";
import { ThemedText } from "@/components/ui";
import { showToast } from "@/utils";

const BarakCard = ({ data, onStartBatch }) => {
    const navigate = useNavigate();

    const handleOpenTable = () => {
        if (data.latest_batch_number) {
            navigate(
                `/barak/${data.id}/batch/${data.latest_batch_number}/tabel-produksi-telur`,
            );
        } else {
            showToast(
                "warning",
                "Batch Tidak Aktif",
                "Tidak ditemukan batch aktif yang terdaftar di barak ini.",
            );
        }
    };

    return (
        <Card className="h-full">
            <CardHeader className="bg-default-50 flex justify-between gap-3 px-4 py-3">
                <ThemedText size="sm" className="font-bold">
                    {data.name}
                </ThemedText>
                <ThemedText variant="secondary" size="xs">
                    {data.staff?.name || "Tidak ada PIC"}
                </ThemedText>
            </CardHeader>
            <Divider />
            <CardBody className="gap-4 px-4 py-4">
                <div className="flex justify-between">
                    <div className="flex flex-col gap-1">
                        <ThemedText
                            variant="caption"
                            size="sm"
                            className="text-tiny font-medium"
                        >
                            Populasi
                        </ThemedText>
                        <div className="flex items-end gap-1">
                            <ThemedText
                                variant="primary"
                                size="2xl"
                                className="font-bold"
                            >
                                {data.current_population?.toLocaleString() || 0}
                            </ThemedText>
                            <ThemedText
                                variant="caption"
                                size="xs"
                                className="mb-1"
                            >
                                ekor
                            </ThemedText>
                        </div>
                    </div>
                    {/* Batch info */}
                    <div className="flex flex-col items-end gap-1">
                        <ThemedText
                            variant="caption"
                            size="sm"
                            className="text-tiny font-medium"
                        >
                            Batch
                        </ThemedText>
                        <div className="flex items-end gap-1">
                            <ThemedText
                                variant="warning"
                                size="2xl"
                                className="font-bold"
                            >
                                #{data.batch_number || "0"}
                            </ThemedText>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <Button
                        size="sm"
                        color="primary"
                        className="font-medium shadow-md"
                        onPress={onStartBatch}
                    >
                        Populasi Baru
                    </Button>
                    <Button
                        size="sm"
                        variant="flat"
                        color="primary"
                        className="font-medium"
                        onPress={handleOpenTable}
                        // isDisabled={!data.latest_batch_id}
                    >
                        Tabel Produksi
                    </Button>
                </div>
            </CardBody>
            <Divider />
            <CardFooter className="bg-default-50 px-4 py-2 transition-colors duration-300">
                <ThemedText
                    variant="caption"
                    className="text-tiny w-full text-center"
                >
                    Last updated:{" "}
                    {data.last_update
                        ? formatDate(data.last_update, { month: "long" })
                        : "Just now"}
                </ThemedText>
            </CardFooter>
        </Card>
    );
};

export default BarakCard;
